import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';

const initailData: any = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker:"",
  prc_date: "",
  prc_yn:"",

  isp_worker: "",
  isp_date: "",
  isp_yn: "",

  category: "",
  answer: "",

  translate_need:"",

  concept_en_1: "",
  concept_en_2: "",
  concept_en_3: "",
  concept_en_4: "",
  concept_en_5: "",
  target_en: "",

  concept_vi_1: "",
  concept_vi_2: "",
  concept_vi_3: "",
  concept_vi_4: "",
  concept_vi_5: "",
  target_vi: "",

  concept_ko_1: "",
  concept_ko_2: "",
  concept_ko_3: "",
  concept_ko_4: "",
  concept_ko_5: "",
  target_ko: "",
};


const Task05CreateDialog = (props: any) => {

  const [data, setData] = useState<any>(initailData);

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };


  const saveComgData = async () => {

    const formData = new FormData();

    if(email != "vanvan511@naver.com" && email != "buiminhthuy730@gmail.com" && email != "go@gmail.com" && data.category == "None" && data.use_check != "F"){
      alert('Category 를 선택하세요.')
      return;
    }

    if(email != "vanvan511@naver.com" && email != "buiminhthuy730@gmail.com" && email != "go@gmail.com" &&
      (data.target_vi == null || data.target_en == null || data.target_ko == null || data.target_vi == "" || data.target_en == "" || data.target_ko == "")
    ){
      alert('target 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email != "vanvan511@naver.com" && email != "buiminhthuy730@gmail.com" && email != "go@gmail.com" &&
      (data.concept_vi_1 == null || data.concept_en_1 == null || data.concept_ko_1 == null || data.concept_vi_1 == "" || data.concept_en_1 == "" || data.concept_ko_1 == "")
    ){
      alert('concept (1) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email != "vanvan522@naver.com" && email != "buiminhthuy730@gmail.com" && email != "go@gmail.com" &&
      (data.concept_vi_2 == null || data.concept_en_2 == null || data.concept_ko_2 == null || data.concept_vi_2 == "" || data.concept_en_2 == "" || data.concept_ko_2 == "")
    ){
      alert('concept (2) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email != "vanvan533@naver.com" && email != "buiminhthuy730@gmail.com" && email != "go@gmail.com" &&
      (data.concept_vi_3 == null || data.concept_en_3 == null || data.concept_ko_3 == null || data.concept_vi_3 == "" || data.concept_en_3 == "" || data.concept_ko_3 == "")
    ){
      alert('concept (3) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email != "vanvan544@naver.com" && email != "buiminhthuy740@gmail.com" && email != "go@gmail.com" &&
      (data.concept_vi_4 == null || data.concept_en_4 == null || data.concept_ko_4 == null || data.concept_vi_4 == "" || data.concept_en_4 == "" || data.concept_ko_4 == "")
    ){
      alert('concept (4) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    if(email != "vanvan555@naver.com" && email != "buiminhthuy750@gmail.com" && email != "go@gmail.com" &&
      (data.concept_vi_5 == null || data.concept_en_5 == null || data.concept_ko_5 == null || data.concept_vi_5 == "" || data.concept_en_5 == "" || data.concept_ko_5 == "")
    ){
      alert('concept (5) 을 입력하세요 (EN , VI , KO).')
      return;
    }

    // if(email != "vanvan511@naver.com" && email != "buiminhthuy730@gmail.com" && email != "go@gmail.com" &&
    //   (data.cot_content_vi == null || data.cot_content_en == null || data.cot_content_ko == null || data.cot_content_vi == "" || data.cot_content_en == "" || data.cot_content_ko == "")
    // ){
    //   alert('Cot_Content (답변에 대한 설명) 를 입력하세요 (EN , VI , KO).')
    //   return;
    // }

    formData.append("email", email);

    formData.append("ins_worker", worker);

    formData.append("datas", JSON.stringify(data));

    // console.log('수정할 데이터', JSON.stringify(data))

    // formData.append("nvConScript", JSON.stringify(con_script));

    await api.post("/vie-05-comgInsert",formData)
    .then((res:any) => { alert("신규작성이 완료되었습니다."); props.updateAfter(); setData(initailData); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const openGuideWindow = () => {
    const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-Commongen.jpg`;

    window.open(imageUrl, '_blank');
  }

  useEffect(() => {
    getAuths();
    setData(initailData);
    // setData(props.rowDetail);
  }, [props.rowDetail]);

  return (
    <Paper sx={{width:"100%", overflow: "auto", padding:"20px"}}>
      {data ? 
      <>
      <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>COMG 신규작성</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box>
        <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >

          {/* <Box display="flex" justifyContent="center"> */}
          <Box display="flex">

            <Box display="flex" sx={{marginLeft: "50px"}}>
              <Box sx={{width:"100%"}}>
                
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"96px"}}>Category</Box>
                  <Select id="category" value={data.category} onChange={(e) => {setData({ ...data, category: e.target.value });}} sx={{color:"green",width:"250px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
                    <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
                    <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
                    <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
                    <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
                    <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
                    <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
                  </Select>
                  <Button variant="contained" size="small" color="secondary" sx={{fontWeight:700, margin:"8px 16px 8px 250px"}} onClick={() => openGuideWindow()}>
                    OPEN GUIDE
                  </Button>
                </Box>
              </Box>
            </Box>
        
          {/* </form> */}
          </Box>

          <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
                {/* <Box sx={{fontSize:"14px", fontWeight:700,width:"90%"}}>기존 스크립트(0 줄)</Box>
                <Box sx={{fontSize:"14px", fontWeight:700,width:"100%"}}>수집 SRT(0 줄)</Box> */}
                <Box sx={{fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700,width:"100%"}}></Box>
              </Box>
              

            </Box>

            <Box sx={{height:"100%", overflow:"auto", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
          <Box display="flex" justifyContent="center" >

          <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
            <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Target</Box>
                      <Box><textarea value={data.target_en || ""} onChange={(e) => {setData({ ...data, target_en: e.target.value });}} style={{width:"410px",minHeight:"80px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Concepts</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>1</Box>
                    <Box><textarea value={data.concept_en_1 || ""} onChange={(e) => {setData({ ...data, concept_en_1: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>2</Box>
                  <Box><textarea value={data.concept_en_2 || ""} onChange={(e) => {setData({ ...data, concept_en_2: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>3</Box>
                  <Box><textarea value={data.concept_en_3 || ""} onChange={(e) => {setData({ ...data, concept_en_3: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>4</Box>
                  <Box><textarea value={data.concept_en_4 || ""} onChange={(e) => {setData({ ...data, concept_en_4: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>5</Box>
                  <Box><textarea value={data.concept_en_5 || ""} onChange={(e) => {setData({ ...data, concept_en_5: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>VI</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Target</Box>
                      <Box><textarea spellCheck="false" value={data.target_vi || ""} onChange={(e) => {setData({ ...data, target_vi: e.target.value });}} style={{width:"410px",minHeight:"80px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Concepts</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>1</Box>
                    <Box><textarea spellCheck="false" value={data.concept_vi_1 || ""} onChange={(e) => {setData({ ...data, concept_vi_1: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>2</Box>
                    <Box><textarea spellCheck="false" value={data.concept_vi_2 || ""} onChange={(e) => {setData({ ...data, concept_vi_2: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>3</Box>
                  <Box><textarea spellCheck="false" value={data.concept_vi_3 || ""} onChange={(e) => {setData({ ...data, concept_vi_3: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>4</Box>
                  <Box><textarea spellCheck="false" value={data.concept_vi_4 || ""} onChange={(e) => {setData({ ...data, concept_vi_4: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>5</Box>
                  <Box><textarea spellCheck="false" value={data.concept_vi_5 || ""} onChange={(e) => {setData({ ...data, concept_vi_5: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Target</Box>
                      <Box><textarea value={data.target_ko || ""} onChange={(e) => {setData({ ...data, target_ko: e.target.value });}} style={{width:"410px",minHeight:"80px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Concepts</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>1</Box>
                  <Box><textarea value={data.concept_ko_1 || ""} onChange={(e) => {setData({ ...data, concept_ko_1: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>2</Box>
                  <Box><textarea value={data.concept_ko_2 || ""} onChange={(e) => {setData({ ...data, concept_ko_2: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>3</Box>
                  <Box><textarea value={data.concept_ko_3 || ""} onChange={(e) => {setData({ ...data, concept_ko_3: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>4</Box>
                  <Box><textarea value={data.concept_ko_4 || ""} onChange={(e) => {setData({ ...data, concept_ko_4: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>5</Box>
                  <Box><textarea value={data.concept_ko_5 || ""} onChange={(e) => {setData({ ...data, concept_ko_5: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            
          </Box>
        </Box>

      </Box>
      <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveComgData();
          }}
        >
          SAVE
        </Button>
      </Box>
      </> : "데이터가 없습니다."}
      
    </Paper>
  );
};

export default Task05CreateDialog;
